export const findModifiedItems = (originalData, changedData) => {
  const modifiedItems = {};

  for (const key in changedData) {
    if (changedData.hasOwnProperty(key) && originalData.hasOwnProperty(key) && originalData[key] !== changedData[key]) {
      modifiedItems[key] = changedData[key];
    }
  }

  return modifiedItems;
};
